/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_Customer_ServiceInputs */

const en_admin_settings_tabs_customer_service = /** @type {(inputs: Admin_Settings_Tabs_Customer_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer Service`)
};

const zh_admin_settings_tabs_customer_service = /** @type {(inputs: Admin_Settings_Tabs_Customer_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客服`)
};

/**
* | output |
* | --- |
* | "Customer Service" |
*
* @param {Admin_Settings_Tabs_Customer_ServiceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_customer_service = /** @type {((inputs?: Admin_Settings_Tabs_Customer_ServiceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_Customer_ServiceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_tabs_customer_service(inputs)
	return zh_admin_settings_tabs_customer_service(inputs)
});
export { admin_settings_tabs_customer_service as "admin.settings.tabs.customer_service" }